"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationWorkflow = void 0;
var react_1 = __importStar(require("react"));
var contexts_1 = require("../../contexts");
var screens_1 = require("../../screens");
var utils_1 = require("../../utils");
var useErrorManager_1 = require("../../contexts/ErrorContext/useErrorManager");
var ErrorManager_1 = __importDefault(require("../Error/ErrorManager"));
var RegistrationWorkflow = function (props) {
    var _a = (0, react_1.useState)(false), isAccountExist = _a[0], setIsAccountExist = _a[1];
    var _b = (0, useErrorManager_1.useErrorManager)(), triggerError = _b.triggerError, errorManagerConfig = _b.errorManagerConfig;
    var _c = (0, contexts_1.useRegistrationContext)(), actions = _c.actions, navigate = _c.navigate;
    var errorDisplayConfig = __assign(__assign(__assign({}, errorManagerConfig), props.errorDisplayConfig), { onClose: function () {
            if (props.errorDisplayConfig && props.errorDisplayConfig.onClose)
                props.errorDisplayConfig.onClose();
            if (errorManagerConfig.onClose)
                errorManagerConfig === null || errorManagerConfig === void 0 ? void 0 : errorManagerConfig.onClose();
        } });
    var _d = props.initialScreenIndex, initialScreenIndex = _d === void 0 ? 0 : _d, _e = props.successScreen, successScreen = _e === void 0 ? react_1.default.createElement(screens_1.RegistrationSuccessScreen, null) : _e, _f = props.existingAccountSuccessScreen, existingAccountSuccessScreen = _f === void 0 ? react_1.default.createElement(screens_1.ExistingAccountSuccessScreen, null) : _f, _g = props.isInviteRegistration, isInviteRegistration = _g === void 0 ? false : _g, _h = props.children, children = _h === void 0 ? isInviteRegistration
        ? [
            react_1.default.createElement(screens_1.EulaScreen, { key: "EulaScreen" }),
            react_1.default.createElement(screens_1.CreatePasswordScreen, { key: "CreatePasswordScreen" }),
            react_1.default.createElement(screens_1.AccountDetailsScreen, { key: "AccountDetailsScreen" }),
        ]
        : [
            react_1.default.createElement(screens_1.EulaScreen, { key: "EulaScreen" }),
            react_1.default.createElement(screens_1.CreateAccountScreen, { key: "CreateAccountScreen" }),
            react_1.default.createElement(screens_1.VerifyCodeScreen, { key: "VerifyCodeScreen" }),
            react_1.default.createElement(screens_1.CreatePasswordScreen, { key: "CreatePasswordScreen" }),
            react_1.default.createElement(screens_1.AccountDetailsScreen, { key: "AccountDetailsScreen" }),
        ] : _h;
    var screens = __spreadArray([], (Array.isArray(children) ? children : [children]), true);
    var totalScreens = screens.length;
    var _j = (0, react_1.useState)(initialScreenIndex < 0 ? 0 : initialScreenIndex > totalScreens - 1 ? totalScreens - 1 : initialScreenIndex), currentScreen = _j[0], setCurrentScreen = _j[1];
    var _k = (0, react_1.useState)(false), showSuccessScreen = _k[0], setShowSuccessScreen = _k[1];
    var _l = (0, react_1.useState)({
        Eula: {
            accepted: false,
        },
        CreateAccount: {
            emailAddress: '',
        },
        VerifyCode: {
            code: '',
            isAccountExist: false,
        },
        CreatePassword: {
            password: '',
            confirmPassword: '',
        },
        AccountDetails: {
            firstName: '',
            lastName: '',
        },
        Other: {},
    }), screenData = _l[0], setScreenData = _l[1];
    var updateScreenData = function (data) {
        var Other = screenData.Other;
        var screenId = data.screenId, values = data.values, accountExists = data.isAccountExist;
        if (accountExists) {
            setIsAccountExist(accountExists);
            setShowSuccessScreen(accountExists);
        }
        if (!Object.keys(screenData).includes(screenId)) {
            setScreenData(function (oldData) {
                var _a;
                return (__assign(__assign({}, oldData), { Other: __assign(__assign({}, oldData.Other), (_a = {}, _a[screenId] = values, _a)) }));
            });
        }
        else if (Object.keys(Other).includes(screenId)) {
            setScreenData(function (oldData) {
                var _a;
                return (__assign(__assign({}, oldData), { Other: __assign(__assign({}, Other), (_a = {}, _a[screenId] = __assign(__assign({}, Other[screenId]), values), _a)) }));
            });
        }
        else {
            setScreenData(function (oldData) {
                var _a;
                return (__assign(__assign({}, oldData), (_a = {}, _a[screenId] = values, _a)));
            });
        }
    };
    var finishRegistration = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var Eula, CreateAccount, VerifyCode, CreatePassword, AccountDetails, Other, userInfo, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!(actions && actions.completeRegistration)) return [3 /*break*/, 2];
                    Eula = screenData.Eula, CreateAccount = screenData.CreateAccount, VerifyCode = screenData.VerifyCode, CreatePassword = screenData.CreatePassword, AccountDetails = screenData.AccountDetails, Other = screenData.Other;
                    userInfo = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, Eula), CreateAccount), VerifyCode), CreatePassword), AccountDetails), Other), data.values);
                    return [4 /*yield*/, actions
                            .completeRegistration(userInfo)
                            .then(function (_a) {
                            var email = _a.email, organizationName = _a.organizationName;
                            updateScreenData({
                                screenId: 'RegistrationSuccessScreen',
                                values: { email: email, organizationName: organizationName },
                            });
                            setShowSuccessScreen(true);
                        })
                            .catch(function (_error) {
                            triggerError(_error);
                        })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (isInviteRegistration) {
            var params = (0, utils_1.parseQueryString)(window.location.search);
            updateScreenData({ screenId: 'CreateAccount', values: { emailAddress: params.email } });
            updateScreenData({ screenId: 'VerifyCode', values: { code: params.code } });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(contexts_1.RegistrationWorkflowContextProvider, { currentScreen: currentScreen, totalScreens: totalScreens, nextScreen: function (data) {
            try {
                updateScreenData(data);
                if (data.isAccountExist) {
                    setIsAccountExist(true);
                    setShowSuccessScreen(true);
                }
                if (currentScreen === totalScreens - 1)
                    return finishRegistration(data);
                setCurrentScreen(function (i) { return i + 1; });
            }
            catch (_error) {
                triggerError(_error);
            }
        }, previousScreen: function (data) {
            updateScreenData(data);
            if (currentScreen === 0) {
                navigate(-1);
            }
            setCurrentScreen(function (i) { return i - 1; });
        }, screenData: screenData, updateScreenData: updateScreenData, isInviteRegistration: isInviteRegistration },
        react_1.default.createElement(ErrorManager_1.default, __assign({}, errorDisplayConfig, { mode: "dialog" }), showSuccessScreen
            ? isAccountExist
                ? existingAccountSuccessScreen
                : successScreen
            : screens[currentScreen])));
};
exports.RegistrationWorkflow = RegistrationWorkflow;
